import { render, staticRenderFns } from "./CompanyMultiRestaurantTabEmployeeMealSummary.vue?vue&type=template&id=3fba045e&scoped=true"
import script from "./CompanyMultiRestaurantTabEmployeeMealSummary.vue?vue&type=script&lang=js"
export * from "./CompanyMultiRestaurantTabEmployeeMealSummary.vue?vue&type=script&lang=js"
import style0 from "./CompanyMultiRestaurantTabEmployeeMealSummary.vue?vue&type=style&index=0&id=3fba045e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fba045e",
  null
  
)

export default component.exports